import { render, staticRenderFns } from "./EditorContentBlockSelector.vue?vue&type=template&id=1a9d4fba&scoped=true&"
import script from "./EditorContentBlockSelector.vue?vue&type=script&lang=js&"
export * from "./EditorContentBlockSelector.vue?vue&type=script&lang=js&"
import style0 from "./EditorContentBlockSelector.vue?vue&type=style&index=0&id=1a9d4fba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a9d4fba",
  null
  
)

export default component.exports